import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import api from "../../../api";
import SnackContext from "../../../components/SnackContext";

const LogoutDialog = (props) => {
    const [open, setOpen] = React.useState(props?.open);
    const navigate = useNavigate();
    const { setSnackMessage } = React.useContext(SnackContext);

    React.useEffect(() => {
        setOpen(props?.open);
    }, [props?.open]);

    const closeDialog = () => {
        setOpen(false);
        props?.onClose();
    };

    const confirmLogout = async () => {
        closeDialog();

        const response = await api.users.logout();
        setSnackMessage(response);

        if(response?.status === 200){
            navigate("/login");
        }
    }

    return (
        <Dialog open={open} onClose={closeDialog}>
            <DialogTitle>Confirm:</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to logout?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>No</Button>
                <Button onClick={confirmLogout} variant="contained" autoFocus>Yes</Button>
            </DialogActions>
        </Dialog>
    );
};

export default LogoutDialog;
